import { getScoreLabel, SCORE_COLORS } from "../constants";
import { useLocale } from "../../../context/LanguageContext";

interface LeadScoreBadgeProps {
  score: number;
}

export function LeadScoreBadge({ score }: LeadScoreBadgeProps) {
  const { t } = useLocale();
  const label = getScoreLabel(score);
  const colorClass = SCORE_COLORS[label];

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${colorClass}`}
      title={t("leads.score.tooltip", { score })}
    >
      {label === "hot" && "🔥"}
      {label === "warm" && "🌡️"}
      {label === "cold" && "❄️"}
      {t(`leads.score.${label}`)}
    </span>
  );
}
